import React, { ReactNode } from 'react';

import urls from 'constants/urls';
import { filterSearchQuery } from 'utils/query-string-params';

import LinkAsColumn from 'components/LinkAsColumn';
import { preserveStubsUrl } from 'utils/general';
import { TextLinkProps } from '@johnlewispartnership/wtr-ingredients/ingredients/TextLink';

type Props = {
  children: ReactNode;
  className?: string;
  id?: string | null;
  originComponent?: string | null;
  onClick?: () => void;
  title?: string;
  totalNumberOfItems?: number;
};

const goToTrolleyDefaultPropOnClick = () => {};

const GoToTrolley = ({
  children,
  className = '',
  id = null,
  onClick = goToTrolleyDefaultPropOnClick,
  originComponent = null,
  title = 'Go to your shopping trolley',
  totalNumberOfItems,
}: Props) => {
  const linkProps = {
    'aria-label': title,
    className,
    id: id || undefined,
    onClick,
    title,
    'data-testid': 'header-trolley-link',
    'data-actiontype': 'redirect',
    'data-origincomponent': originComponent,
    'data-shortdescription': 'Goes to trolley details',
    'data-item-count': totalNumberOfItems,
    component: 'a',
  } as TextLinkProps;

  const href = preserveStubsUrl(`${urls.trolleyPage}?${filterSearchQuery('featureflag')}`);

  return (
    <LinkAsColumn
      {...{
        ...linkProps,
        href,
        underline: 'hover',
      }}
    >
      {children}
    </LinkAsColumn>
  );
};

export default GoToTrolley;
